// import assetPackPreload from '../../static/assets/asset-pack-preload-cartoonito.json';
import assetPackPreload from '../../static/assets/asset-pack-preload-batwheels.json';
import assetPackCommon from '../../static/assets/asset-pack-common.json';
import assetPackTitle from '../../static/assets/asset-pack-title.json';
import assetPackIntro from '../../static/assets/asset-pack-intro.json';
import assetPackLevelSelect from '../../static/assets/asset-pack-level-select.json';
import assetPackGame from '../../static/assets/asset-pack-game.json';
// import assetPackGame32 from '../../static/assets/asset-pack-game-32.json';
import assetPackGameSky from '../../static/assets/asset-pack-game-sky.json';

import assetPackThemeFunStreet from '../../static/assets/asset-pack-theme-funstreet.json';
import assetPackThemeScrapyard from '../../static/assets/asset-pack-theme-scrapyard.json';
import assetPackThemeCitySky from '../../static/assets/asset-pack-theme-citysky.json';
import assetPackThemeDocks from '../../static/assets/asset-pack-theme-docks.json';
import assetPackThemeFrozenStreet from '../../static/assets/asset-pack-theme-frozenstreet.json';

import { ThemeName, ThemeNameValues } from './game/level/themes/theme';
import { Sounds } from './sounds';
import { AssetsToLoad, SpineAsset } from './core/modules/AssetManager';

export const AssetPack = {
  Common: 'asset-pack-common',
  Title: 'asset-pack-title',
  Intro: 'asset-pack-intro',
  Game: 'asset-pack-game',
  // Game32: 'asset-pack-game-32',
  GameSky: 'asset-pack-game-sky',
  LevelSelect: 'asset-pack-level-select',

  ThemeParkFunStreet: 'asset-pack-theme-funstreet',
  ThemeParkScrapyard: 'asset-pack-theme-scrapyard',
  ThemeParkCitySky: 'asset-pack-theme-citysky',
  ThemeParkDocks: 'asset-pack-theme-docks',
  ThemeParkFrozenStreet: 'asset-pack-theme-frozenstreet'
} as const;

export const SpineAssets = {
  BatComputer: 'batcomputer',

  // Vehicles.
  BamPrank: 'bam-prank',
  BibiJestah: 'bibi-jestah',
  BatwingQuizz: 'batwing-quizz',
  RedbirdDucky: 'redbird-ducky',
  BuffSnowy: 'buff-snowy',

  // Charge Strips.
  ChargeStrip: 'charge-strip',
  ChargeStripScrap: 'scrap-charge-strip',
  ChargeStripDock: 'dock-charge-strip',
  ChargeStripSky: 'sky-charge-strip',
  ChargeStripIce: 'ice-charge-strip',

  // Obstacles.
  QuestionCloud: 'question-cloud',
  Ink: 'ink',
  Snowdrift: 'snowdrift'
} as const;

// Placeholder.
export const audioLookup: Set<string> = new Set();

export const assetPackLookup: Map<string, any> = new Map([
  [AssetPack.Common, assetPackCommon],
  [AssetPack.Title, assetPackTitle],
  [AssetPack.Intro, assetPackIntro],
  [AssetPack.Game, assetPackGame],
  // [AssetPack.Game32, assetPackGame32],
  [AssetPack.GameSky, assetPackGameSky],
  [AssetPack.LevelSelect, assetPackLevelSelect],

  [AssetPack.ThemeParkFunStreet, assetPackThemeFunStreet],
  [AssetPack.ThemeParkScrapyard, assetPackThemeScrapyard],
  [AssetPack.ThemeParkCitySky, assetPackThemeCitySky],
  [AssetPack.ThemeParkDocks, assetPackThemeDocks],
  [AssetPack.ThemeParkFrozenStreet, assetPackThemeFrozenStreet]
]);

// Contains functions that return the assets to load at different bit.

export const assetsToPreload = (scene: Phaser.Scene) => {
  scene.load.pack('pack', assetPackPreload as any);
};

export const assetsToLoad = (scene: Phaser.Scene) => {
  scene.load.pack('asset-pack-common', assetPackCommon as any);
  scene.load.pack('asset-pack-title', assetPackTitle as any);
  // scene.load.pack('asset-pack-game', assetPackGame as any);
  // scene.load.pack('asset-pack-game-32', assetPackGame32 as any);
  // scene.load.pack('asset-pack-level-select', assetPackLevelSelect as any);
  // scene.load.pack('asset-pack-character-select', assetPackCharacterSelect as any);

  // Load all sounds defined in Sounds.Track
  audioToLoad(scene, Object.values(Sounds.Track));
};

export const buildSpineLookup = (): Map<string, SpineAsset> => {
  const assetPath = 'assets/animations/';
  const spineAssets: SpineAsset[] = [
    // Vehicles.
    { key: SpineAssets.BamPrank, preMultipliedAlpha: true },
    { key: SpineAssets.BibiJestah, preMultipliedAlpha: true },
    { key: SpineAssets.RedbirdDucky, preMultipliedAlpha: true },
    { key: SpineAssets.BatwingQuizz, preMultipliedAlpha: true },
    { key: SpineAssets.BuffSnowy, preMultipliedAlpha: true },

    // Obstacles.
    { key: SpineAssets.Ink, preMultipliedAlpha: true },
    { key: SpineAssets.QuestionCloud, preMultipliedAlpha: true },
    { key: SpineAssets.Snowdrift, preMultipliedAlpha: true },

    // Charge Strips.
    { key: SpineAssets.ChargeStrip, jsonURL: 'charge_strip.json', atlasURL: 'charge_strip.atlas', preMultipliedAlpha: true },
    { key: SpineAssets.ChargeStripScrap, preMultipliedAlpha: true },
    { key: SpineAssets.ChargeStripDock, preMultipliedAlpha: true },
    { key: SpineAssets.ChargeStripSky, preMultipliedAlpha: true },
    { key: SpineAssets.ChargeStripIce, preMultipliedAlpha: true },

    { key: SpineAssets.BatComputer, jsonURL: 'BC.json', atlasURL: 'BC.atlas', preMultipliedAlpha: true }
  ];

  const spineAssetLookup: Map<string, SpineAsset> = new Map();

  // Inject full asset path and any missing values.
  for (const spineAsset of spineAssets) {
    if (spineAsset.jsonURL) spineAsset.jsonURL = assetPath + spineAsset.jsonURL;
    else spineAsset.jsonURL = assetPath + spineAsset.key + '.json';

    if (spineAsset.atlasURL) spineAsset.atlasURL = assetPath + spineAsset.atlasURL;
    else spineAsset.atlasURL = assetPath + spineAsset.key + '.atlas';

    spineAssetLookup.set(spineAsset.key, spineAsset);
  }

  return spineAssetLookup;
};

export const dynamicGameSceneAssetsToLoad = (scene: Phaser.Scene, theme: ThemeNameValues): AssetsToLoad => {
  let dynamicAssets: AssetsToLoad = {
    assetPacks: [],
    spines: [],
    audio: []
  };

  switch (theme) {
    case ThemeName.FunStreet:
      dynamicAssets.assetPacks.push(AssetPack.ThemeParkFunStreet);
      dynamicAssets.spines.push(SpineAssets.BamPrank);
      dynamicAssets.spines.push(SpineAssets.ChargeStrip);
      break;
    case ThemeName.Scrapyard:
      dynamicAssets.assetPacks.push(AssetPack.ThemeParkScrapyard);
      dynamicAssets.spines.push(SpineAssets.BibiJestah);
      dynamicAssets.spines.push(SpineAssets.ChargeStripScrap);
      break;
    case ThemeName.Docks:
      dynamicAssets.assetPacks.push(AssetPack.ThemeParkDocks);
      dynamicAssets.spines.push(SpineAssets.RedbirdDucky);
      dynamicAssets.spines.push(SpineAssets.ChargeStripDock);
      dynamicAssets.spines.push(SpineAssets.Ink);
      break;
    case ThemeName.CitySky:
      dynamicAssets.assetPacks.push(AssetPack.ThemeParkCitySky);
      dynamicAssets.spines.push(SpineAssets.BatwingQuizz);
      dynamicAssets.spines.push(SpineAssets.ChargeStripSky);
      dynamicAssets.spines.push(SpineAssets.QuestionCloud);
      break;
    case ThemeName.FrozenStreet:
      dynamicAssets.assetPacks.push(AssetPack.ThemeParkFrozenStreet);
      dynamicAssets.spines.push(SpineAssets.BuffSnowy);
      dynamicAssets.spines.push(SpineAssets.ChargeStripIce);
      dynamicAssets.spines.push(SpineAssets.Snowdrift);
      break;
    default:
      break;
  }

  return dynamicAssets;
};

/**
 * Load all sounds passed in the soundsToLoad array in four formats, .webm, .m4a, .ogg., and .mp3.
 *
 * @param scene - The scene to use for loading.
 * @param soundsToLoad - Array of sounds to load.
 */
export const audioToLoad = (scene: Phaser.Scene, soundsToLoad: string[]) => {
  const assetPath = 'assets/sounds/';
  const versions = ['webm', 'm4a', 'ogg', 'mp3'];

  const addAllVersions = (fileName: string, path: string, versions: string[]): [string, string[]] => {
    let output: string[] = [];
    for (const extension of versions) output.push(`${path}${fileName}.${extension}`);
    return [fileName, output];
  };

  for (const sound of soundsToLoad) {
    scene.load.audio(...addAllVersions(sound, assetPath, versions));
  }
};
